import React from "react"
import "./startbootstrap-freelancer-gh-pages/css/styles.css"
const Footer=()=>{
    return(
        
        <div class="copyright py-4 text-center text-white" style={{backgroundColor:"black"}}>
            <br/><br/>
            
                <div class="col-md-12 ">
                        <h2 class="text-uppercase mb-4" style={{color:"gold"}}>MyP<span style={{color:"white"}}>o</span>rtF<span style={{color:"white"}}>o</span>li<span style={{color:"white"}}>o</span></h2>
                        <a class="btn btn-outline-light btn-social mx-1" href="www.facebook.com"><i class="fab fa-fw fa-facebook-f"></i></a>
                        <a class="btn btn-outline-light btn-social mx-1" href="www.twitte.com"><i class="fab fa-fw fa-twitter"></i></a>
                        <a class="btn btn-outline-light btn-social mx-1" href="https://www.linkedin.com/in/nag-ashish-s-v-384a81176/"><i class="fab fa-fw fa-linkedin-in"></i></a>
                        <a class="btn btn-outline-light btn-social mx-1" href="www.github.com/ashishsv029"><i class="fab fa-fw fa-github"></i></a>
                    </div>
                    <br/>
            <div class="container">Copyrights 2020 @ <span style={{color:"gold"}}>NAG ASHISH S V</span> Portfolio. All Rights Reserved</div>
        </div>
    )
}

export default Footer